/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import _get from 'lodash/get'
import { USER_ROLES } from 'constants/user'

export const getData = state => state.auth
export const getToken = state => getData(state).token.value
export const getRegistrationStep = state => getData(state).registrationStep
export const getAccessToken = state => _get(getToken(state), 'access')
export const getUserRole = state => _get(getToken(state), 'role')
export const getAuthHeaders = state => ({
  Authorization: `Bearer ${getAccessToken(state)}`,
})
export const isTokenLoading = state => _get(getData(state), ['token', 'loading'])
export const isUserAuthorizated = state => {
  const role = getUserRole(state)
  return role === USER_ROLES.subscriptionUser
}
